import store from 'services/redux/store'
import { createAlerts } from 'utils/create-alerts'

export default createAlerts( store.dispatch );
